import { useMemo } from 'react';

import { getEditorInlineCommentOptions } from '@confluence/annotation-provider-inline-comments/entry-points/editor';
import {
	useAnnotationsDispatch,
	useAnnotationManager,
} from '@confluence/annotation-provider-store';
import { fg } from '@confluence/feature-gating';

export const useEditorAnnotationProviderOptions = ({
	pageId,
	editorActions,
	triggerAnalyticsEvent,
	updateUnresolvedInlineComment,
}: {
	pageId: string;
	editorActions: any;
	triggerAnalyticsEvent: any;
	updateUnresolvedInlineComment: any;
}) => {
	const { setEditorCreateProps, setEditorViewProps } = useAnnotationsDispatch();
	const annotationManager = useAnnotationManager();

	return useMemo(
		() => ({
			inlineComment: getEditorInlineCommentOptions({
				pageId,
				editorActions,
				triggerAnalyticsEvent,
				updateUnresolvedInlineComment,
				setEditorCreateProps,
				setEditorViewProps,
				editorAnnotationProviderManagersEnabled: fg(
					'confluence_frontend_editor_annotation_manager',
				),
			}),
			annotationManager,
		}),
		[
			pageId,
			triggerAnalyticsEvent,
			editorActions,
			updateUnresolvedInlineComment,
			setEditorCreateProps,
			setEditorViewProps,
			annotationManager,
		],
	);
};
